/**
 * Created by Phatbass on 25/02/16.
 */

angular.module('dekky.forms.validators.numericOnly', [])
    .directive('numericOnly', function(){
    return {
        require: '?ngModel',
        link: function(scope, element, attr, ngModelController) {

            ngModelController.$parsers.push(function (inputValue) {
                var transformedInput = inputValue ? inputValue.replace(/[^\d.]/g,'') : null;

                if (transformedInput!=inputValue) {
                    ngModelController.$setViewValue(transformedInput);
                    ngModelController.$render();
                }

                return transformedInput;
            });
        }
    };
});